module.exports = __webpack_public_path__ + "img/galeria-aquario-4.664e30c7.jpg";